import * as React from "react";
import EdButton from "../../../../generic/edButton";
import ObTransactionHistory from "../obTransactionHistory";
import { dateTimeFormat } from "../../../../service/dateTimeService";
import moment from "moment";
import { ChipColorKeyComb, ChipStatusComb } from "../../obConstants";
import Tag from "../../../../generic/tag";
import { AObMfSipTrsHist } from "../../../../service/orderBook/obApiService";

export interface IObMfSipDtlContentProps {
	data: any;
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export interface IObMfSipDtlContentState {
	trsHist: Array<any>;
}

class ObMfSipDtlContent extends React.Component<IObMfSipDtlContentProps, IObMfSipDtlContentState> {
	state = { trsHist: [] };

	onButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		console.log(e);
	};

	mfSipTrsHistRes = (res: any) => {
		if (res.data) {
			this.setState({ trsHist: res.data.childOrderDetails.map((d: any) => ({ date: d.date, status: d.status })) });
		}
	};

	componentDidMount() {
		AObMfSipTrsHist(this.mfSipTrsHistRes, this.props.data.SIPRegNo);
	}

	render() {
		return (
			<div className="dtl_wrp mf_sip_dtl_cont_wrap">
				<div className="dtl_wrp_rw mf_sip_info_row ">
					<div className="dtls_cont dtl_lft">
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Amount</div>
							<div className="dtl_amt taRight">{this.props.data.amount || "--"}</div>
						</div>
					</div>
					<div className="dtls_cont dtl_right">
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Frequency</div>
							<div className="dtl_amt taRight">{this.props.data.frequency || "--"}</div>
						</div>
					</div>
				</div>
				<hr className="slim_line" />
				<div className="mf_info_row dtl_wrp_rw ">
					<div className="dtls_cont dtl_lft">
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Installments Paid</div>
							<div className="dtl_amt taRight">
								{this.props.data.instalementsPaid || "--"}/{this.props.data.totalInstalments}
							</div>
						</div>
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Installments Failed</div>
							<div className="dtl_amt taRight">---</div>
						</div>
					</div>
					<div className="dtls_cont dtl_right">
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Mandate id</div>
							<div className="dtl_amt taRight">{this.props.data.mandateID || "--"}</div>
						</div>
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Mandate Status</div>
							<div className="dtl_amt taRight">
								{this.props.data.mandateSts ? (
									<Tag
										value={ChipStatusComb[this.props.data.mandateSts.toLowerCase()]}
										color={ChipColorKeyComb[this.props.data.mandateSts.toLowerCase()]}
									/>
								) : (
									"--"
								)}
							</div>
						</div>
					</div>
				</div>
				<hr className="slim_line" />
				<div className="mf_info_row dtl_wrp_rw ">
					<div className="dtls_cont dtl_lft">
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Next Due Date</div>
							<div className="dtl_amt taRight">{moment(dateTimeFormat(this.props.data.dueDate)).format("D MMM YYYY")}</div>
						</div>
					</div>
					<div className="dtls_cont dtl_right"></div>
				</div>
				{/* buttons to perform different actions on click */}
				<div className="ob_btns btn_wrapper mg-t20 mg-b50">
					<div className="btn_left">
						{/* button to cancel */}
						<EdButton value="Cancel Order" btnTyp="secondary" onClick={this.props.onCancelClick} className="mg-r20" slim />
					</div>
				</div>
				{this.state.trsHist.length >= 1 && <ObTransactionHistory data={this.state.trsHist} />}
			</div>
		);
	}
}

export default ObMfSipDtlContent;
